import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const Payments = lazy(() => import('./Payments'));

export const paymentRoutes: RouteObject[] = [
  { path: 'payments', element: <Payments /> },
];
